import React from 'react';
export default class ErrorBoundary extends React.Component{
  constructor(props){super(props);this.state={error:null}}
  static getDerivedStateFromError(error){return{error}}
  componentDidCatch(error,info){console.error('SabayBuy UI error',error,info)}
  render(){if(this.state.error)return <main className="fatal"><h1>Something went wrong</h1><p>The page could not be displayed. Your transaction data was not changed.</p><button onClick={()=>location.reload()}>Reload SabayBuy</button></main>;return this.props.children}
}
